/**
 * Hero Logo Fade on Scroll
 * - Logo is visible (100% opacity) at top of page
 * - Logo fades to transparent as user scrolls down
 * - Logo fades back to 100% when scrolling back to top
 */

class HeroLogoFade extends HTMLElement {
  constructor() {
    super();
    this.logo = this.querySelector('.logo-block');
    if (!this.logo) return;

    this.isScrolling = false;
    
    // Get settings from data attributes or use defaults
    this.fadeStart = parseInt(this.dataset.fadeStart) || 0;
    this.fadeEnd = parseInt(this.dataset.fadeEnd) || 300;
    
    this.init();
  }

  init() {
    // Set initial state - visible at top
    this.updateLogoOpacity();

    // Listen to scroll events
    window.addEventListener('scroll', () => this.handleScroll(), { passive: true });
  }

  handleScroll() {
    if (!this.isScrolling) {
      window.requestAnimationFrame(() => {
        this.updateLogoOpacity();
        this.isScrolling = false;
      });
      this.isScrolling = true;
    }
  }

  updateLogoOpacity() {
    const scrollY = window.scrollY;
    let opacity = 1;

    if (scrollY <= this.fadeStart) {
      // At top: logo is fully visible
      opacity = 1;
    } else if (scrollY > this.fadeStart && scrollY < this.fadeEnd) {
      // Fading out range: calculate opacity based on scroll position
      const fadeRange = this.fadeEnd - this.fadeStart;
      const fadeProgress = scrollY - this.fadeStart;
      opacity = 1 - (fadeProgress / fadeRange);
    } else {
      // Scrolled past fade end: logo is hidden
      opacity = 0;
    }

    // Apply opacity
    this.logo.style.opacity = opacity;
    this.logo.style.transition = 'opacity 0.3s ease';
  }
}

customElements.define('hero-logo-fade', HeroLogoFade);

